import { CustomComponentLabel, CustomComponentType } from '../../../../../enums';
import { PersonalFinancialTypeSelect } from '../personal-financial-type-select/personal-financial-type-select';
import { getKey } from '../../../../../components/form-components/simple-inputs/extended-field-helper';
import { createSubaccountDefaultEditConfiguration } from '../configuration';

export class PersonalOtherAssetsTypeSelect extends PersonalFinancialTypeSelect {
	static schema(...extend: any) {
		return PersonalFinancialTypeSelect.schema(
			{
				label: CustomComponentLabel()[CustomComponentType.personalOtherAssetsTypeSelect],
				type: CustomComponentType.personalOtherAssetsTypeSelect,
				key: CustomComponentType.personalOtherAssetsTypeSelect
			},
			...extend
		);
	}

	static editForm = createSubaccountDefaultEditConfiguration(CustomComponentType.personalOtherAssetsTypeSelectOptions);

	static get builderInfo() {
		return {
			title: CustomComponentLabel()[CustomComponentType.personalOtherAssetsTypeSelect],
			weight: 10,
			schema: PersonalOtherAssetsTypeSelect.schema()
		};
	}

	// @ts-ignore
	get key(): string {
		return getKey(this, super.key);
	}
}
